module.exports = __webpack_public_path__ + "static/media/Girls Like You.f0e79e01.mp3";